var _rect, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlay(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 55,
    height: 55,
    viewBox: "0 0 55 55",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 55,
    height: 55,
    rx: 27.5,
    fill: "white"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_0_721)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M33.9236 23.2323C31.1356 21.6729 26.6607 19.1689 19.7198 15.2825C19.2518 14.9735 18.7134 14.933 18.2482 15.0905L30.1568 26.9991L33.9236 23.2323Z",
    fill: "#32BBFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.2482 15.0905C18.161 15.12 18.0762 15.1556 17.9951 15.1986C17.4814 15.4765 17.1039 16.0112 17.1039 16.6875V37.3107C17.1039 37.9869 17.4813 38.5216 17.9951 38.7995C18.0761 38.8424 18.1609 38.8782 18.2479 38.9079L30.1568 26.9991L18.2482 15.0905Z",
    fill: "#32BBFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.1568 26.9991L18.2479 38.9079C18.7133 39.0666 19.2517 39.0292 19.7198 38.7156C26.4509 34.9464 30.8754 32.472 33.6957 30.8994C33.7742 30.8553 33.8511 30.8121 33.9271 30.7694L30.1568 26.9991Z",
    fill: "#32BBFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.1039 26.9991V37.3107C17.1039 37.9869 17.4813 38.5216 17.9951 38.7995C18.0761 38.8425 18.1609 38.8782 18.2479 38.9079L30.1568 26.9991H17.1039Z",
    fill: "#2C9FD9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.7198 15.2826C19.1641 14.9156 18.5088 14.9261 17.9951 15.1987L29.9761 27.1798L33.9235 23.2323C31.1356 21.6729 26.6607 19.1689 19.7198 15.2826Z",
    fill: "#29CC5E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.9762 26.8184L17.9951 38.7995C18.5088 39.072 19.1641 39.0878 19.7198 38.7156C26.4509 34.9464 30.8754 32.472 33.6957 30.8994C33.7742 30.8553 33.8511 30.8121 33.9272 30.7694L29.9762 26.8184Z",
    fill: "#D93F21"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.8961 26.9991C38.8961 26.4277 38.6078 25.851 38.0364 25.5312C38.0364 25.5312 36.9677 24.9349 33.6919 23.1027L29.7955 26.9991L33.6957 30.8993C36.9355 29.0802 38.0363 28.4669 38.0363 28.4669C38.6078 28.1471 38.8961 27.5705 38.8961 26.9991Z",
    fill: "#FFD500"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.0364 28.4669C38.6078 28.1471 38.8961 27.5705 38.8961 26.9991H29.7955L33.6957 30.8993C36.9355 29.0803 38.0364 28.4669 38.0364 28.4669Z",
    fill: "#FFAA00"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_0_721"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(16 15)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlay);
export default __webpack_public_path__ + "static/media/play.2ff668be85e9f256c68d36a46044ea38.svg";
export { ForwardRef as ReactComponent };